<template>
  <div style="width: 100%">
    <el-table
      style="margin-top: 10px;"
      :data="his_list"
      border
    >
      <el-table-column label="拒审广告id" prop="original_adgroup_id" />
      <el-table-column label="新开广告id" prop="target_adgroup_id" />
      <el-table-column label="新开时间" prop="created_at">
        <template slot-scope="scope">
          {{ new Date(parseInt(scope.row.created_at)*1000).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ") }}
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>
<script>

import PaginationRight from '@/components/PaginationRight/index.vue'
import { InterPutRuleHistory } from '@/api/customer'

export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10,
        account_id: null
      },
      his_list: [],
      total: 0
    }
  },
  methods: {
    fetchPageSize(e) {
      this.query.pageSize = e
      this.open(this.account_id, this.rule_id)
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
      this.open(this.account_id, this.rule_id)
    },
    open(account_id, rule_id) {
      InterPutRuleHistory({
        account_id: account_id,
        rule_id: rule_id
      }).then(res => {
        this.his_list = res.data.list
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
